<template>
    <!-- DESKTOP -->
    <div
        v-if="!isMobile"
        :class="{
            'picture-documenter-container': true,
            'is-second': isSecondScreen,
            'comparison-enabled-variant': imageComparisonEnabled,
            'construcode-document-active': isConstrucodeDocumentActive,
        }"
    >
        <div class="left-side">
            <div class="header" v-b-toggle="'picDoc' + _uid">
                <icon name="regular/clock" color="var(--light)" scale=".8" />

                <h6 v-if="hasPictureOrRender && selectedPicture.date">
                    {{ selectedPicture.date.substr(-5) != '00:00' ? selectedPicture.date : moment(selectedPicture.date, 'DD/MM/YYYY').format('DD/MM/YYYY') }}
                </h6>
                <h6 v-else-if="hasPictureOrRender">
                    {{
                        selectedPicture.name || 'Projeto ' + (renders.length && (renders.findIndex((r) => r == selectedPicture) + 1).toString().padStart(2, 0))
                    }}
                </h6>
                <h6 v-else>
                    {{ $t('Components_Viewer_PictureDocumenter_1') }}
                </h6>

                <div class="arrows">
                    <icon v-if="!currentSelectedCollapseFlag" color="var(--light)" scale=".8" name="caret-down" />
                    <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                </div>
            </div>
            <div class="footer">
                <b-collapse v-show="hasPictureOrRender" v-model="currentSelectedCollapseFlag" :id="'picDoc' + _uid" class="pic-doc-collapse">
                    <vue-custom-scrollbar class="internal-scroll">
                        <div v-if="models.length > 0" class="collapse-container">
                            <div class="title" v-b-toggle="'3dModels_' + _uid">
                                <h6>{{ $t('Components_Viewer_UI_PictureDocumenter_1') }}</h6>

                                <icon v-if="!modelsCollapse" color="var(--light)" scale=".8" name="caret-down" />
                                <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                            </div>
                            <b-collapse v-model="modelsCollapse" :id="'3dModels_' + _uid">
                                <div class="picture-date" @click="changePicture(model, true)" v-for="model in models" :key="model.id">
                                    {{ model.name }}
                                </div>
                            </b-collapse>
                        </div>

                        <div v-if="renders.length > 0" class="collapse-container">
                            <div class="title" v-b-toggle="'renders_' + _uid">
                                <h6>Renders</h6>

                                <icon v-if="!rendersCollapse" color="var(--light)" scale=".8" name="caret-down" />
                                <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                            </div>
                            <b-collapse v-model="rendersCollapse" :id="'renders_' + _uid">
                                <div
                                    class="picture-date"
                                    @click="changePicture(render, false, true)"
                                    v-for="(render, index) in reorderedRenders"
                                    :key="render.id"
                                >
                                    {{ render.name || $t('keyword64') + (index + 1).toString().padStart(2, 0) }}
                                </div>
                            </b-collapse>
                        </div>

                        <div v-if="pictures && pictures.length > 0" class="collapse-container">
                            <div class="title" v-b-toggle="'pictures_' + _uid">
                                <h6>{{ $t('Components_Viewer_UI_PictureDocumenter_2') }}</h6>

                                <icon v-if="!picturesCollapse" color="var(--light)" scale=".8" name="caret-down" />
                                <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                            </div>
                            <b-collapse v-model="picturesCollapse" :id="'pictures_' + _uid">
                                <div
                                    :class="{
                                        'picture-date': true,
                                        selected: selectedPicture.url == picture.url,
                                        'filter-false': !isDateMatchingFilter(picture.date),
                                    }"
                                    @click="changePicture(picture)"
                                    v-for="picture in pictures"
                                    :key="picture.id"
                                >
                                    {{ picture.date.substr(-5) != '00:00' ? picture.date : moment(picture.date, 'DD/MM/YYYY').format('DD/MM/YYYY') }}
                                </div>
                            </b-collapse>
                        </div>
                    </vue-custom-scrollbar>
                </b-collapse>
                <div v-show="hasPictureOrRender && !currentSelectedCollapseFlag" id="lastInfo" class="collapsed-last-info">
                    <p v-show="hasPictureOrRender && !currentSelectedCollapseFlag">
                        {{ !selectedPicture.date ? `${getFormattedDate(moment, selectedPicture.created_at)}` : getFormattedDate(moment, selectedPicture.date) }}
                    </p>
                </div>

                <div
                    v-show="!hasPictureOrRender"
                    id="lastInfo"
                    class="collapsed-last-info justify-content-center align-items-center"
                    :class="[!hasPictureOrRender ? 'd-flex' : 'd-none']"
                >
                    <p>N/A</p>
                </div>
            </div>
        </div>
        <div class="right-side">
            <button @click.stop="toggleImageComparison" class="toggle-comparison-button">
                <img v-if="!imageComparisonEnabled" src="@/assets/img/misc/image-divide-white.svg" alt="" />
                <icon v-else color="var(--light)" scale="1" name="ci-image" />
            </button>
        </div>
    </div>

    <!-- MOBILE -->
    <div
        v-else
        :class="{
            'picture-documenter-container': true,
            'is-second': isSecondScreen,
            'comparison-enabled-variant': imageComparisonEnabled,
            'is-mobile': true,
            'is-open': isDocumenterOpen,
        }"
    >
        <div class="clock-button" @click="openDocumenter">
            <icon name="regular/clock" color="white" scale="1.2" />
        </div>

        <div class="date-selector-container">
            <div class="current-selected-container" v-b-toggle="'picDoc' + _uid">
                <h6 v-if="hasPictureOrRender && selectedPicture.date">
                    {{ selectedPicture.date.substr(-5) != '00:00' ? selectedPicture.date : moment(selectedPicture.date, 'DD/MM/YYYY').format('DD/MM/YYYY') }}
                </h6>
                <h6 v-else-if="hasPictureOrRender">
                    {{
                        selectedPicture.name || 'Projeto ' + (renders.length && (renders.findIndex((r) => r == selectedPicture) + 1).toString().padStart(2, 0))
                    }}
                </h6>
                <h6 v-else>
                    {{ $t('Components_Viewer_PictureDocumenter_1') }}
                </h6>

                <div class="arrows ml-2">
                    <icon v-if="!currentSelectedCollapseFlag" color="var(--light)" scale=".8" name="chevron-down" />
                    <icon v-else color="var(--light)" scale=".8" name="chevron-up" />
                </div>
            </div>
            <div class="selector-container">
                <b-collapse v-show="hasPictureOrRender" v-model="currentSelectedCollapseFlag" :id="'picDoc' + _uid" class="pic-doc-collapse">
                    <vue-custom-scrollbar class="internal-scroll">
                        <div v-if="models.length > 0" class="collapse-container">
                            <div class="title" v-b-toggle="'3dModels_' + _uid">
                                <h6>{{ $t('Components_Viewer_UI_PictureDocumenter_1') }}</h6>

                                <icon v-if="!modelsCollapse" color="var(--light)" scale=".8" name="caret-down" />
                                <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                            </div>
                            <b-collapse v-model="modelsCollapse" :id="'3dModels_' + _uid">
                                <div class="picture-date" @click="changePicture(model, true)" v-for="model in models" :key="model.id">
                                    {{ model.name }}
                                </div>
                            </b-collapse>
                        </div>

                        <div v-if="renders.length > 0" class="collapse-container">
                            <div class="title" v-b-toggle="'renders_' + _uid">
                                <h6>Renders</h6>

                                <icon v-if="!rendersCollapse" color="var(--light)" scale=".8" name="caret-down" />
                                <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                            </div>
                            <b-collapse v-model="rendersCollapse" :id="'renders_' + _uid">
                                <div class="picture-date" @click="changePicture(render)" v-for="(render, index) in reorderedRenders" :key="render.id">
                                    {{ render.name || $t('keyword64') + (index + 1).toString().padStart(2, 0) }}
                                </div>
                            </b-collapse>
                        </div>

                        <div v-if="pictures && pictures.length > 0" class="collapse-container">
                            <div class="title" v-b-toggle="'pictures_' + _uid">
                                <h6>{{ $t('Components_Viewer_UI_PictureDocumenter_2') }}</h6>

                                <icon v-if="!picturesCollapse" color="var(--light)" scale=".8" name="caret-down" />
                                <icon v-else color="var(--light)" scale=".8" name="caret-up" />
                            </div>
                            <b-collapse v-model="picturesCollapse" :id="'pictures_' + _uid">
                                <div
                                    :class="{ 'picture-date': true, selected: selectedPicture.url == picture.url }"
                                    @click="changePicture(picture)"
                                    v-for="picture in pictures"
                                    :key="picture.id"
                                >
                                    {{ picture.date.substr(-5) != '00:00' ? picture.date : moment(picture.date, 'DD/MM/YYYY').format('DD/MM/YYYY') }}
                                </div>
                            </b-collapse>
                        </div>
                    </vue-custom-scrollbar>
                </b-collapse>

                <div
                    v-show="!hasPictureOrRender"
                    id="lastInfo"
                    class="collapsed-last-info justify-content-center align-items-center"
                    :class="[!hasPictureOrRender ? 'd-flex' : 'd-none']"
                >
                    <p>N/A</p>
                </div>
            </div>
        </div>

        <div class="close-button" @click="closeDocumenter">
            <icon name="times" color="white" scale="1.2" />
        </div>
    </div>
</template>

<script>
import 'vue-awesome/icons/regular/clock'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/caret-up'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/regular/image'
import vueCustomScrollbar from 'vue-custom-scrollbar'

// Vuex
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
        vueCustomScrollbar,
    },
    props: {
        projectId: {},
        pictures: {
            type: null,
            default: function () {
                return []
            },
            required: true,
        },
        renders: {
            type: null,
            default: function () {
                return []
            },
            required: true,
        },
        models: {
            type: null,
            default: function () {
                return []
            },
        },
        isSecondScreen: Boolean,
        imageComparisonEnabled: Boolean,
        isConstrucodeDocumentActive: Boolean,

        selectedPicture: Object,
    },
    data() {
        return {
            datesMatchingFilter: [],
            // Mobile only vars
            isDocumenterOpen: false,
            isDropdownOpen: false,
            currentSelectedCollapseFlag: false,

            rendersCollapse: false,
            modelsCollapse: false,
            picturesCollapse: true,

            isMobile: false,
        }
    },
    computed: {
        ...mapState(['dateFilterViewer']),
        ...mapGetters('dateFilterViewer', ['getDatesByProjectId']),

        hasPictureOrRender() {
            return (this.pictures && this.pictures.length) || (this.renders && this.renders.length) || (this.models && this.models.length)
        },

        reorderedRenders() {
            let rendersCopy = [...this.renders]
            return rendersCopy.reverse()
        },
    },
    watch: {
        dateFilterViewer: {
            handler() {
                this.filterDates()
                this.findFilteredImage()
            },
            deep: true,
        },
        pictures() {
            this.filterDates()
        },
    },
    methods: {
        openDocumenter() {
            this.isDocumenterOpen = true
        },

        closeDocumenter() {
            this.isDocumenterOpen = false
            this.isDropdownOpen = false
        },

        getFormattedDate(moment, date) {
            let diff = moment.duration(moment().diff(moment(date, 'DD/MM/YYYY')))
            let formattedString = ''
            if (diff.years() > 0) {
                let years = diff.years()
                let months = diff.months()
                formattedString +=
                    years +
                    (years > 1 ? this.$t('keyword9') : this.$t('keyword9')) +
                    (months > 0 ? this.$t('keyword12') + months + (months > 1 ? this.$t('keyword7') : this.$t('keyword6')) : '')
            } else if (diff.months() > 0) {
                let months = diff.months()
                let days = diff.days()
                formattedString +=
                    months +
                    (months > 1 ? this.$t('keyword7') : this.$t('keyword6')) +
                    (days > 0 ? this.$t('keyword12') + days + (days > 1 ? this.$t('keyword5') : this.$t('keyword4')) : '')
            } else if (diff.days() > 0) {
                let days = diff.days()
                formattedString += days + (days > 1 ? this.$t('keyword5') : this.$t('keyword4'))
            } else {
                formattedString = this.$t('today')
                return formattedString
            }
            return formattedString + this.$t('keyword11')
        },

        toggleImageComparison() {
            this.$emit('imageComparisonChange', !this.imageComparisonEnabled)
            if (this.isSecondScreen) {
                this.$emit('closedFromRightDocumenter', {
                    picture: this.selectedPicture,
                    isModel: Boolean(this.selectedPicture.urn),
                    isRender: Boolean(this.selectedPicture.back),
                })
            }
        },

        changePicture(picture, isModel = false, isRender = false) {
            this.$root.$emit('bv::toggle::collapse', 'picDoc' + this._uid)
            this.$emit('pictureChange', { picture, isModel, isRender })
        },

        isDateMatchingFilter(date) {
            if (this.getDatesByProjectId(this.projectId).length == 0) return true
            return this.datesMatchingFilter.includes(date)
        },

        filterDates() {
            let dates = this.getDatesByProjectId(this.projectId)
            this.datesMatchingFilter = []
            if (dates.length > 0) {
                dates.forEach((date) => {
                    this.pictures.forEach((pic) => {
                        let picDate = pic.date.split(' ')[0]
                        if (picDate == date) {
                            this.datesMatchingFilter.push(pic.date)
                        }
                    })
                })
            }
        },
        findFilteredImage() {
            let picturesMatchingFilter = this.pictures.filter((pic) => this.datesMatchingFilter.includes(pic.date))

            if (picturesMatchingFilter.length > 0) {
                // Get more recent date
                if (this.isSecondScreen) {
                    if (this.picturesMatchingFilter && this.picturesMatchingFilter.length >= 2) {
                        this.changePicture(picturesMatchingFilter[1])
                    } else if (picturesMatchingFilter[0]) {
                        this.changePicture(picturesMatchingFilter[0])
                    }
                } else if (picturesMatchingFilter[0]) {
                    this.changePicture(picturesMatchingFilter[0])
                }
            }
        },
    },
    mounted() {
        this.isMobile = this.$Mobile.verify()
        this.filterDates()
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/picture-documenter.scss';
</style>
